var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "projectsApp", staticClass: "projects__app" },
    [
      _c("h2", {
        staticClass: "projects__title",
        class: _vm.activeReference !== null ? "projects__title_active" : "",
        domProps: { textContent: _vm._s(_vm.$t("projects.title")) },
      }),
      _vm._v(" "),
      _c(
        "collapse-transition",
        { attrs: { duration: 500, easing: "ease-in-out" } },
        [
          _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.activeReference === null,
                expression: "activeReference === null",
              },
            ],
            staticClass: "projects__desc",
            domProps: { textContent: _vm._s(_vm.$t("projects.desc")) },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "projects__reference-list",
          class:
            _vm.activeReference !== null
              ? "projects__reference-list_active"
              : "",
        },
        _vm._l(_vm.references, function (reference) {
          return _c(
            "div",
            {
              key: reference.id,
              ref: "projectReference" + reference.id + "Id",
              refInFor: true,
              staticClass: "projects__reference",
              class: [
                reference.isActive ? "projects__reference_active" : "",
                reference.hasOwnProperty("attrId") ? reference.attrId : "",
              ],
            },
            [
              _c(
                "div",
                {
                  staticClass: "projects__reference-wrapper",
                  on: {
                    click: function ($event) {
                      return _vm.activateReference(reference)
                    },
                  },
                },
                [
                  _c("div", {
                    staticClass: "projects__reference-title",
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t(
                          "projects.reference.items[" + reference.id + "].name"
                        )
                      ),
                    },
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "projects__reference-arrow",
                    domProps: {
                      innerHTML: _vm._s(require("../img/projectArrow.svg")),
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "collapse-transition",
                { attrs: { duration: 500, easing: "ease-in-out" } },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: reference.isActive,
                          expression: "reference.isActive",
                        },
                      ],
                      staticClass: "projects__reference-content",
                      class: reference.isActive
                        ? "projects__reference-content_active"
                        : "projects__reference-content_notactive",
                    },
                    [
                      reference.cards.type === "simpleCards"
                        ? _c("div", { staticClass: "projects__cards" }, [
                            _c(
                              "div",
                              {
                                ref: "projectsSwiperContainer" + reference.id,
                                refInFor: true,
                                staticClass:
                                  "swiper-container projects__swiper",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "presentation__controls" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "presentation__arrows" },
                                      [
                                        _c("div", {
                                          staticClass:
                                            "swiper-button-prev presentation__button-prev",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              require("../img/arrow-right.svg")
                                            ),
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.firePreviousSlide(
                                                reference.id
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass:
                                            "swiper-button-next presentation__button-next",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              require("../img/arrow-right.svg")
                                            ),
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.fireNextSlide(
                                                reference.id
                                              )
                                            },
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "swiper-wrapper" },
                                  _vm._l(
                                    reference.cards.items,
                                    function (item, cardKey) {
                                      return _c(
                                        "div",
                                        {
                                          staticClass:
                                            "swiper-slide projects__card-slide",
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "projects__card",
                                              class: [
                                                item.nolink
                                                  ? "projects__card_nolink"
                                                  : "",
                                              ],
                                              style: {
                                                background:
                                                  "" + item.background,
                                                color: "" + item.fontColor,
                                              },
                                              attrs: {
                                                href: _vm.$t(
                                                  "projects.reference.items[" +
                                                    reference.id +
                                                    "].cards[" +
                                                    cardKey +
                                                    "].link"
                                                ),
                                                target: "_blank",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "projects__card-content",
                                                },
                                                [
                                                  _c("div", {
                                                    staticClass:
                                                      "projects__card-title",
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        _vm.$t(
                                                          "projects.reference.items[" +
                                                            reference.id +
                                                            "].cards[" +
                                                            cardKey +
                                                            "].title"
                                                        )
                                                      ),
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("div", {
                                                    staticClass:
                                                      "projects__card-text",
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        _vm.$t(
                                                          "projects.reference.items[" +
                                                            reference.id +
                                                            "].cards[" +
                                                            cardKey +
                                                            "].text"
                                                        )
                                                      ),
                                                    },
                                                  }),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass:
                                                  "projects__card-arrow",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    require("../img/projectArrow.svg")
                                                  ),
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass:
                                                  "projects__card-img",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    require("../img/projects/" +
                                                      reference.id +
                                                      "_" +
                                                      cardKey +
                                                      ".svg")
                                                  ),
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]
                            ),
                          ])
                        : reference.cards.type === "gridCol"
                        ? _c(
                            "div",
                            { staticClass: "projects__gridcols" },
                            _vm._l(
                              reference.cards.items,
                              function (item, cardKey) {
                                return _c(
                                  "div",
                                  { staticClass: "projects__gridcol" },
                                  _vm._l(
                                    item.components,
                                    function (component, componentkey) {
                                      return _c(
                                        "div",
                                        {
                                          staticClass:
                                            "projects__gridcol-component",
                                        },
                                        [
                                          component.type === "gridColText"
                                            ? _c("div", {
                                                staticClass:
                                                  "projects__gridcol-text",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.$t(
                                                      "projects.reference.items[" +
                                                        reference.id +
                                                        "].cards[" +
                                                        cardKey +
                                                        "].components[" +
                                                        componentkey +
                                                        "].text"
                                                    )
                                                  ),
                                                },
                                              })
                                            : component.type ===
                                              "gridColShadedText"
                                            ? _c("div", {
                                                staticClass:
                                                  "projects__gridcol-shaded",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.$t(
                                                      "projects.reference.items[" +
                                                        reference.id +
                                                        "].cards[" +
                                                        cardKey +
                                                        "].components[" +
                                                        componentkey +
                                                        "].text"
                                                    )
                                                  ),
                                                },
                                              })
                                            : component.type === "gridColBigImg"
                                            ? _c("div", {
                                                staticClass:
                                                  "projects__gridcol-img",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    require("../img/projects/" +
                                                      reference.id +
                                                      "_" +
                                                      cardKey +
                                                      ".svg")
                                                  ),
                                                },
                                              })
                                            : component.type === "gridColCard"
                                            ? _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "projects__gridcol-card",
                                                  attrs: {
                                                    href: _vm.$t(
                                                      "projects.reference.items[" +
                                                        reference.id +
                                                        "].cards[" +
                                                        cardKey +
                                                        "].components[" +
                                                        componentkey +
                                                        "].link"
                                                    ),
                                                    target: "_blank",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "projects__gridcol-card-container",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "projects__gridcol-card-img",
                                                        },
                                                        [
                                                          _c("img", {
                                                            attrs: {
                                                              src: _vm.assetUrl(
                                                                _vm.$t(
                                                                  "projects.reference.items[" +
                                                                    reference.id +
                                                                    "].cards[" +
                                                                    cardKey +
                                                                    "].components[" +
                                                                    componentkey +
                                                                    "].img"
                                                                )
                                                              ),
                                                              alt: "",
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "projects__gridcol-card-content",
                                                        },
                                                        [
                                                          _c("div", {
                                                            staticClass:
                                                              "projects__gridcol-card-text",
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                _vm.$t(
                                                                  "projects.reference.items[" +
                                                                    reference.id +
                                                                    "].cards[" +
                                                                    cardKey +
                                                                    "].components[" +
                                                                    componentkey +
                                                                    "].text"
                                                                )
                                                              ),
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("div", {
                                                    staticClass:
                                                      "projects__gridcol-card-arrow",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        require("../img/projectArrow.svg")
                                                      ),
                                                    },
                                                  }),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                )
                              }
                            ),
                            0
                          )
                        : _vm._e(),
                    ]
                  ),
                ]
              ),
            ],
            1
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }